import React from 'react';

import { DashboardPrintViewContext } from './DashboardPrintViewContext';

type DashboardFilterCVAdminProviderProps = {
  children: React.ReactNode;
  isPrintView: boolean;
};

export const DashboardPrintViewProvider = ({
  children,
  isPrintView,
}: DashboardFilterCVAdminProviderProps) => {
  const value = React.useMemo(
    () => ({
      isPrintView,
    }),
    [isPrintView],
  );

  return (
    <DashboardPrintViewContext.Provider value={value}>
      {children}
    </DashboardPrintViewContext.Provider>
  );
};
